import { getSelectedDisplayElementId } from '../features/editor/shared/state-management/selectors';
import * as ElementSelectors from './element';
import * as ContentSelectors from './content';
import { CONTENT_TYPE } from '../constants';
import { mostCommonValueInArr } from '../util/array';
import { isNil } from '../util/object';

export const getDefaultFont = (state) => state.text.defaultFont;
export const getFontByPSName = (state, psName) =>
  state.text.fonts.find((font) => font.psName === psName);
export const getFontList = (state) => state.text.fonts;
export const isEditingTextId = (state) => state.text.isEditingTextId;
export const isEditingText = (state) => Boolean(isEditingTextId(state));

export const getEditingTextElementId = (state) => {
  const editingTextContentId = isEditingTextId(state);
  if (isNil(editingTextContentId)) return null;

  return ElementSelectors.getElementIdByContentId(state, editingTextContentId);
};

export const getMostUsedFont = (state) => {
  const allText = ContentSelectors.getAllText(state);
  const fontPSName = mostCommonValueInArr(allText, 'font');
  if (isNil(fontPSName)) return null;

  return getFontByPSName(state, fontPSName);
};

// todo: would be nice to refactor with createSelector
export const getSelectedFont = (state) => {
  const selectedElementId = getSelectedDisplayElementId(state);
  if (!selectedElementId) {
    return getDefaultFont(state).psName;
  }
  const selectedContent = ElementSelectors.getContent(state, selectedElementId);
  if (!selectedContent) {
    return getDefaultFont(state).psName;
  }
  const { contentType, contentId } = selectedContent;
  if (contentType !== CONTENT_TYPE.TEXT) {
    return getDefaultFont(state).psName;
  }

  const textStyle = ContentSelectors.getTextStyle(state, contentId);
  const selectedFontName = textStyle.fontFamily;
  const activeFont = getFontByPSName(state, selectedFontName);

  // if the font is not active, then the selected font can not be displayed
  return isNil(activeFont) ? null : selectedFontName;
};

export const getFontDataByPSName = (state, psName) => {
  if (isNil(state.text.fontData)) {
    return null;
  }
  return state.text.fontData[psName];
};
